import React from 'react';
import Wrapper from 'components/Wrapper';
import TechRepChecklistFunctional from './index.function';
import { back_icon } from 'asset/icons';
import Text from 'components/Text';
import { fontSizes } from 'appconstants';
import { ReactSVG } from 'react-svg';
import SectionCard from 'components/SectionCard';
import RowView from 'components/RowView';

const TechRepChecklist = () => {
  const { navigate } = TechRepChecklistFunctional();

  return (
    <Wrapper>
      {/* Header */}
      <div className='flex items-center gap-3 mb-6'>
        <div
          onClick={() => navigate(-1)}
          className='h-10 w-10 cursor-pointer rounded-md flex items-center justify-center bg-muted hover:bg-muted/50 transition'
        >
          <ReactSVG src={back_icon} />
        </div>
        <Text text='TechRep Checklist' size={fontSizes.h24} className='font-bold' />
      </div>

      {/* Content */}
      <div className='grid grid-cols-1 lg:grid-cols-2 gap-6'>
        {/* LEFT COLUMN */}
        <div className='space-y-6'>
          <SectionCard title='Contact Sales Rep for Account'>
            <RowView label='Sales Rep' value='Sales Rep' />
            <RowView label='Basic Account Information' value='Basic Account information' />
            <RowView label='Issues (Rejections/Complaints)' value='No issues identified' />
            <RowView label='Contact Name' value='Ali Shah' />
            <RowView label='Contact Number' value='03468726060' />
            <RowView label='Country of Origin' value='Pakistan' className='border-b-0' />
          </SectionCard>

          <SectionCard title='Contact Buyer / Ripener'>
            <RowView label='Ripener Name' value='Ahmed Khan' />
            <RowView label='Ripener Number' value='+92 300 1234567' />
            <RowView label='Ripener Email' value='ahmed.khan@gmail.com' />
            <RowView label='Type of Rooms' value='Storage Room' />
            <RowView label='# of Rooms' value='3' />
            <RowView label='Age of Rooms' value='3 Years' />
            <RowView
              label='Warehouse Address/Getting in (Guard, shack info, etc.)'
              value='Plot 45, Industrial Area, Lahore – Guard at main entrance'
              className='flex-col gap-3'
              detailTextClassName='text-left'
            />
            <RowView label='Time/Date to be at the Warehouse' value='08-Jan-2026, 10:00 AM' />
            <RowView label='Time Room Checks are Preformed' value='09:00 AM – 05:00 PM' />
            <RowView label='Time/Dates of Load Arrivals' value='Every Monday & Thursday' />
            <RowView label='Send Itinerary' value='09:45 AM – 10:30 AM' />
            <RowView label='Visit Retail Stores' value='No' className='border-b-0' />
          </SectionCard>

          <SectionCard title='Observe Arrival Inspections'>
            <RowView label='Date/Time of Observation' value='08-Jan-2026, 09:30 AM' />
            <RowView label='Receiving Dock Temperature' value='20°C' />
            <RowView
              label='Arrival Inspection Notes'
              value='Load clean, properly packed, signs of slight moisture on bottom crates'
              className='flex-col gap-3'
              detailTextClassName='text-left'
            />
            <RowView
              label='Perform PCMS'
              value='Minor defects in 2 crates, overall score acceptable'
              className='flex-col gap-3 border-b-0'
              detailTextClassName='text-left'
            />
          </SectionCard>

          <SectionCard title='Complete Room Inspections'>
            <RowView label='Room Capacity' value='200 crates' />
            <RowView label='Type of Doors' value='Sliding insulated doors' />
            <RowView label='Type of Humidification System' value='Spray mist system' />
            <RowView label='Type of Ethylene Generator' value='Automated release system' />
            <RowView label='Complete Daily Updates' value='Day 1 / Day 2' />
            <RowView
              label='Complete Wrap Up Notes'
              value='Room in good condition, temperature and humidity stable, ethylene generator functioning properly, ready for next ripening cycle.'
              className='flex-col gap-3 border-b-0'
              detailTextClassName='text-left'
            />
          </SectionCard>
        </div>

        {/* RIGHT COLUMN */}
        <div className='space-y-6'>
          <SectionCard title='Contact Port Manager'>
            <RowView
              label='Discuss Quality of fruit Being Received by the Customer'
              value='Fruit quality satisfactory at the time of receipt'
              className='flex-col gap-3 border-b-0'
              detailTextClassName='text-left'
            />
          </SectionCard>

          <SectionCard title='Observe Room Checks'>
            <RowView label='# Room Checks / Day' value='2 (if checked twice a day)' />
            <RowView
              label='Room Check Morning Observations'
              value='Temperature stable, ethylene levels normal, ventilation working fine'
              className='flex-col gap-3'
              detailTextClassName='text-left'
            />
            <RowView
              label='Room Check Afternoon Observation'
              value='Ventilation normal, ethylene levels consistent, room clean and organized'
              className='flex-col gap-3'
              detailTextClassName='text-left'
            />
            <RowView label='Ripening Cycle' value='Bananas – 5 days, ethylene ripening' />
            <RowView label='Venting Cycle' value='Continuous ventilation with automatic fans' />
            <RowView label='Target Color' value='Mangoes – Golden Yellow' className='border-b-0' />
          </SectionCard>

          <SectionCard title='Observe Box / Pallet Quality'>
            <RowView label='Comment' value='Pallets clean, boxes properly labeled' />
            <RowView label='Attachments' value='-' className='border-b-0' />
          </SectionCard>

          <SectionCard title='Observe Staging / Selection'>
            <RowView label='Date/Time of Observation' value='08-Jan-2026, 10:00 AM' />
            <RowView label='Selection Handling Observation' value='Selection handling acceptable' />
            <RowView label='Outbound Color' value='Golden Orange' />
            <RowView label='Staging Time' value='2 hours' />
            <RowView label='Pulp Temps at Staging (3)' value='19°C, 20°C, 19.5°C' />
            <RowView label='Loading Dock Ambient Temp' value='22°C' />
            <RowView label='Time on Dock' value='30 minutes' />
            <RowView label='Truck Temperature' value='18°C' />
            <RowView label='Attachments' value='-' className='border-b-0' />
          </SectionCard>
        </div>
      </div>
    </Wrapper>
  );
};

export default TechRepChecklist;
